import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../../config";

// The optional last step of setup: connect Gmail so rate cons come in on
// their own. Hidden once connected, or when the link can't be made.
export default function GmailOffer({ token }) {
  const [url, setUrl] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.post(
          `${API_URL}/gmail-connect/from-book-it/${token}`,
        );
        const data = res?.data;
        if (!cancelled && typeof data?.url === "string" && !data.connected) {
          setUrl(data.url);
        }
      } catch {
        // Optional: setup is already done without it.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (!url) return null;
  return (
    <section className="flex flex-col gap-2 rounded-2xl border border-indigo-200 bg-indigo-50 px-[16px] py-[16px] font-[Roboto]">
      <p className="m-0 text-[12px] font-semibold uppercase tracking-wide text-indigo-700">
        Optional
      </p>
      <h2 className="m-0 text-[18px] font-bold text-slate-900">
        Skip forwarding rate cons
      </h2>
      <p className="m-0 text-[15px] leading-snug text-slate-700">
        Connect Gmail and we'll pick up the rate confirmations brokers email
        you. We only read broker emails with a rate con attached.
      </p>
      <a
        href={url}
        className="mt-1 self-start rounded-xl bg-indigo-600 px-[16px] py-2.5 text-[16px] font-semibold text-white no-underline hover:bg-indigo-700"
      >
        Connect Gmail
      </a>
    </section>
  );
}
